define.alias("shared/helpers/json-stringify", "calendar/helpers/json-stringify");